import { IRawStyle } from '@fluentui/merge-styles';

export const selectorCardStyle: IRawStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: 'var(--druid-gap-8)',
    padding: 'var(--druid-space-8) var(--druid-space-10)',
    borderRadius: 'var(--druid-radius-4)',
    border: '1px solid var(--druid-color-border)',
    cursor: 'pointer',
};